import * as React from 'react';
/**
 * Assigns the given value to the given ref (if any).
 */
export function useRefAssignment(value, ref) {
    React.useEffect(function () {
        if (typeof ref === 'function') {
            ref(value);
        }
        else if (ref) {
            ref.current = value;
        }
    }, [ref, value]);
}
useRefAssignment.displayName = 'useRefAssignment';
